import { useState } from "react";
import { Button, Paper } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

import { columns } from "./grid-columns";
import { ServiceTypeForm } from "./service-type.form";
import { SiTrackPage } from "../../../components/si-track-page";
import { ServiceType } from "../../../models/masters/serviceType";
import { serviceTypeFormSchema } from "./service-type-form.schema";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { servicesApiKeyStore } from "../../../api/masters/services-api-key-store";
import { SaveHookFormDialog } from "../../../components/save-hook-form.dialog";
import { UserPermissionName } from "../../../models/user-permission-name";
import { GuardedComponent } from "../../../components/guarded-component";

const styling = {
    paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const ServiceTypePage = () => {

    const [editItem, setEditItem] = useState<Partial<ServiceType>>();

    const handleEditServiceType = (serviceType: ServiceType) => {
        setEditItem(serviceType);
    };

    const handleEditClose = () => {
        setEditItem(undefined);
    };

    const handleCreateServiceType = () => {
        setEditItem({ isActive: true });
    };

    return (
        <SiTrackPage
            title="Service Type"
            actionButton={
                <GuardedComponent requiredPermissions={[UserPermissionName.ADD_SERVICETYPE]}>
                    <Button
                        size="small"
                        variant="contained"
                        disableElevation={true}
                        startIcon={<AddIcon />}
                        onClick={handleCreateServiceType}
                    >
                        Add Service Type
                    </Button>
                </GuardedComponent>
            }
        >
            <Paper elevation={0} style={styling.paperStyle}>
                <SiTrackGrid
                    fileTitle='service_type'
                    dataItemKey="serviceTypeID"
                    columns={columns}
                    queryConfig={servicesApiKeyStore.getServiceTypes()}
                    onEdit={handleEditServiceType}
                    deleteMutationConfig={(deleteItem) => servicesApiKeyStore.deleteServiceType(deleteItem.serviceTypeID)}
                    actionPermissions={{
                        edit: UserPermissionName.EDIT_SERVICETYPE,
                        delete: UserPermissionName.DELETE_SERVICETYPE,
                        export: UserPermissionName.DOWNLOAD_GRID
                    }}
                />
                {editItem && (
                    <SaveHookFormDialog
                        title={editItem.serviceTypeID ? 'UPDATE SERVICE TYPE' : 'CREATE SERVICE TYPE'}
                        config={{
                            saveConfig: editItem.serviceTypeID
                                ? servicesApiKeyStore.updateServiceType()
                                : servicesApiKeyStore.createServiceType(),
                            invalidateRoute: () => servicesApiKeyStore.getServiceTypes(),
                        }}
                        data={editItem}
                        yupSchema={serviceTypeFormSchema}
                        onClose={handleEditClose}
                        size="xs"
                    >
                        <ServiceTypeForm />
                    </SaveHookFormDialog>
                )}
            </Paper>
        </SiTrackPage>
    );
}